import React from 'react';
import { useSelector } from 'react-redux';

export default function useDashboardSelector() {
  const DashboardData = useSelector((state) => state.Dashboard.dashboard_data); // Dashboard data
  const HierarchyData = useSelector((state) => state.Dashboard.hierarchy_data); // Hierarchy data

  return { DashboardData, HierarchyData };
}
